import { graphql } from '@/gql';
import { type DeleteOperatorMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteOperator = async (variables: DeleteOperatorMutationVariables) => {
  return mutationExecute({
    variables,
    mutation: graphql(`
      mutation DeleteOperator($id: String!, $deactivationReason: String!, $isRehireEligible: Boolean, $resignationReason: String!) {
        deleteOperator(
          id: $id
          deactivationReason: $deactivationReason
          isRehireEligible: $isRehireEligible
          resignationReason: $resignationReason
        ) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
          resignationReason
        }
      }
    `),
  });
};
